import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$version/")({
    beforeLoad: ({ params, search }) => {
        throw redirect({
            to: "/$version/texts",
            params: { version: params.version },
            search,
            replace: true,
        });
    },
});
